<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';

const props = defineProps({
  email: { type: String, default: '' },
});

const store = useStore();
const router = useRouter();

const hasEmail = ref(!!props.email);

// This route carries no :accountId, so it cannot be an authenticated route --
// validateLoggedInRoutes resolves the account from route params and would
// bounce us to /app/login. It is registered with skipAuth (same as
// /app/dial) and resolves the account itself instead.
onMounted(async () => {
  if (!props.email) return;

  await store.dispatch('setUser');
  const user = store.getters.getCurrentUser;

  if (!user?.account_id) {
    window.location.assign('/app/login');
    return;
  }

  router.replace({
    path: frontendURL(`accounts/${user.account_id}/dashboard`),
    query: { compose_email: props.email },
  });
});
</script>

<template>
  <div class="flex items-center justify-center h-full">
    <p v-if="hasEmail" class="text-lg text-n-slate-12">
      {{ $t('COMPOSE_REDIRECT.OPENING', { email }) }}
    </p>
    <p v-else class="text-lg text-n-ruby-11">
      {{ $t('COMPOSE_REDIRECT.NO_EMAIL') }}
    </p>
  </div>
</template>
